// Anfrage-Daten fuer Angebots-Modal und Beratungsformular
// (docs/storefront/ANFRAGEFORMULAR-KONZEPT.md). Reine Logik ohne Seitenbezug,
// getestet mit scripts/test-anfrage-daten.mjs. Die Verdrahtung im Browser steht
// in anfrage-formular.js.
(() => {
  if (window.FennextAnfrageDaten) return;

  var EU = [
    'AT',
    'BE',
    'BG',
    'CY',
    'CZ',
    'DE',
    'DK',
    'EE',
    'ES',
    'FI',
    'FR',
    'GR',
    'HR',
    'HU',
    'IE',
    'IT',
    'LT',
    'LU',
    'LV',
    'MT',
    'NL',
    'PL',
    'PT',
    'RO',
    'SE',
    'SI',
    'SK',
  ];
  // Das USt-IdNr.-Praefix weicht nur bei Griechenland vom ISO-Code ab.
  var UST_PRAEFIX = { GR: 'EL' };
  // Nur Laender mit eindeutigem Muster; alle anderen: nicht leer.
  var PLZ_MUSTER = {
    DE: /^\d{5}$/,
    AT: /^\d{4}$/,
    CH: /^\d{4}$/,
    LI: /^\d{4}$/,
    BE: /^\d{4}$/,
    LU: /^\d{4}$/,
    DK: /^\d{4}$/,
    NL: /^\d{4}\s?[A-Za-z]{2}$/,
    FR: /^\d{5}$/,
    IT: /^\d{5}$/,
    ES: /^\d{5}$/,
    PL: /^\d{2}-\d{3}$/,
    CZ: /^\d{3}\s?\d{2}$/,
  };
  // Mailtext fuers Team (immer deutsch); Kundentexte kommen aus den Locales.
  var MOTIV_TEXT = {
    own_image: 'Foto/Bild',
    ready_layout: 'Druckfertige Datei',
    suggestion: 'Motivvorschlag gewünscht',
  };
  var BEFESTIGUNG_TEXT = {
    recommend: 'Bitte empfehlen',
    screws: 'Schrauben',
    velcro: 'Klett',
    magnet: 'Magnet',
  };

  function rund2(n) {
    return Math.round(n * 100) / 100;
  }
  function leer(v) {
    return v === undefined || v === null || String(v).trim() === '';
  }
  function wert(v) {
    return leer(v) ? null : String(v).trim();
  }
  function komma(n) {
    return String(n).replace('.', ',');
  }

  function zahl(v) {
    if (leer(v)) return null;
    // "250 cm" ist eine haeufige Eingabe; andere Einheiten (m, mm) nicht raten.
    var n = Number(
      String(v)
        .trim()
        .replace(/\s*cm$/i, '')
        .replace(',', '.'),
    );
    return isFinite(n) ? n : null;
  }

  function istEuAusland(land) {
    return land !== 'DE' && EU.indexOf(land) > -1;
  }

  function plzOk(land, plz) {
    var p = String(plz || '').trim();
    if (!p) return false;
    return PLZ_MUSTER[land] ? PLZ_MUSTER[land].test(p) : true;
  }

  function ustIdOk(land, ustId) {
    var u = String(ustId || '')
      .replace(/[\s.-]/g, '')
      .toUpperCase();
    var praefix = UST_PRAEFIX[land] || land;
    return u.indexOf(praefix) === 0 && /^[A-Z0-9]{2,12}$/.test(u.slice(praefix.length));
  }

  // Laender fuer den Adressblock: Codes aus anfrage-adresse.liquid (Versandzonen), Namen in
  // der Seitensprache, Deutschland zuerst, Rest alphabetisch. Ohne Intl bleibt der Code.
  function laenderListe(codes, sprache) {
    var namen = null;
    try {
      namen = new Intl.DisplayNames([sprache || 'de'], { type: 'region' });
    } catch (_e) {
      namen = null;
    }
    var liste = (codes || []).map((code) => {
      var name = code;
      try {
        name = (namen && namen.of(code)) || code;
      } catch (_e) {
        name = code;
      }
      return { code: code, name: name };
    });
    liste.sort((a, b) => {
      if (a.code === 'DE') return -1;
      if (b.code === 'DE') return 1;
      return a.name.localeCompare(b.name, sprache || 'de');
    });
    return liste;
  }

  // Varianten wie "Individuelle Größe (Preis pro m²)" (Live-Store, alle Pix-Produkte).
  function istSondergroesse(optionen) {
    return (optionen || []).some((o) => /Individuelle Gr|pro m²/i.test(String(o || '')));
  }

  // "1200×600mm (2:1)" -> 120 x 60 cm
  function formatAusOptionen(optionen) {
    var liste = optionen || [];
    for (let i = 0; i < liste.length; i++) {
      const m = /(\d+)\s*[×x]\s*(\d+)\s*mm/i.exec(String(liste[i] || ''));
      if (m) return { breite_cm: Number(m[1]) / 10, hoehe_cm: Number(m[2]) / 10 };
    }
    return null;
  }

  function flaeche(breiteCm, hoeheCm) {
    var b = zahl(breiteCm),
      h = zahl(hoeheCm);
    if (!(b > 0) || !(h > 0)) return null;
    return rund2((b * h) / 10000);
  }

  // Lange Seite gegen Max-lang, kurze gegen Max-kurz — unabhaengig von der Ausrichtung.
  function groessePruefen(breiteCm, hoeheCm, regel) {
    var f = flaeche(breiteCm, hoeheCm);
    if (f === null) return 'unvollstaendig';
    var r = regel || {};
    if (r.min_m2 && f < r.min_m2) return 'zu_klein';
    var b = zahl(breiteCm),
      h = zahl(hoeheCm);
    if (
      r.max_lang_cm &&
      r.max_kurz_cm &&
      (Math.max(b, h) > r.max_lang_cm || Math.min(b, h) > r.max_kurz_cm)
    )
      return 'zu_gross';
    return 'ok';
  }

  function akustikAuswerten(werte, optionen, regel) {
    var w = werte || {};
    var r = regel || {};
    var breite,
      hoehe,
      ausrichtung = null;
    var format = formatAusOptionen(optionen);
    if (format && !istSondergroesse(optionen)) {
      breite = format.breite_cm;
      hoehe = format.hoehe_cm;
      if (breite !== hoehe) {
        ausrichtung = w['akustik.orientation'] === 'portrait' ? 'portrait' : 'landscape';
        const lang = Math.max(breite, hoehe);
        const kurz = Math.min(breite, hoehe);
        breite = ausrichtung === 'portrait' ? kurz : lang;
        hoehe = ausrichtung === 'portrait' ? lang : kurz;
      }
    } else {
      breite = zahl(w['akustik.width_cm']);
      hoehe = zahl(w['akustik.height_cm']);
      if (breite && hoehe && breite !== hoehe)
        ausrichtung = breite > hoehe ? 'landscape' : 'portrait';
    }
    var oversize = groessePruefen(breite, hoehe, r) === 'zu_gross';
    return {
      // nur fuer Zusammenfassung und Formular; item() uebernimmt es nicht ins JSON
      sondergroesse: !(format && !istSondergroesse(optionen)),
      width_cm: breite || null,
      height_cm: hoehe || null,
      area_m2: flaeche(breite, hoehe),
      orientation: ausrichtung,
      motif: wert(w['akustik.motif']) || 'own_image',
      // Keine Kundenwahl mehr (Entscheidung 18): mehrteilig nur als Folge der Uebergroesse.
      multi_part: oversize,
      mounting: r.befestigung ? wert(w['akustik.mounting']) || 'recommend' : null,
      oversize: oversize,
    };
  }

  // Positionsschluessel der Anfrageliste (Entscheidung 24): gleiche Variante mit anderen
  // Akustik-Angaben ist eine eigene Position, gleiche Angaben erhoehen nur die Menge.
  // Der Datei-Link gehoert bewusst nicht dazu: ein nachgetragener Link aktualisiert die
  // vorhandene Position, statt eine zweite anzulegen (anfrageliste.liquid, hinzufuegen).
  function positionsSchluessel(variantId, akustik) {
    var id = String(variantId);
    if (!akustik) return id;
    return [
      id,
      akustik.orientation,
      akustik.width_cm,
      akustik.height_cm,
      akustik.motif,
      akustik.mounting,
    ]
      .map((v) => (v === null || v === undefined ? '' : String(v)))
      .join('|');
  }

  // Eine Zeile fuer Kunden (Anfrageliste, Formular). texte: Locale-Texte je Wert.
  function zusammenfassung(p, texte) {
    if (!p || !p.motiv) return '';
    var t = texte || {};
    var a = p.akustik;
    if (!a) return t.angaben_fehlen || '';
    var teile = [];
    if (a.sondergroesse) {
      if (a.area_m2)
        teile.push(
          komma(a.width_cm) + ' × ' + komma(a.height_cm) + ' cm (' + komma(a.area_m2) + ' m²)',
        );
    } else if (a.orientation) {
      teile.push(t[a.orientation]);
    }
    teile.push(t[a.motif]);
    if (a.mounting) teile.push(t[a.mounting]);
    if (a.motif !== 'suggestion') teile.push(p.datei_link ? t.datei_da : t.datei_folgt);
    return teile.filter(Boolean).join(' · ');
  }

  // Listenwert ohne Abschlussquote. m2-Positionen ohne bekannte Flaeche (Akustikbild
  // einer anderen Seite) zaehlen wie bisher mit Faktor 1.
  // ziel: { waehrung, kurs } der aktuellen Seite (Shopify.currency) — das Tracking meldet
  // den Wert in dieser Waehrung (FennextTrackingConfig.waehrung = cart.currency), Google
  // und Microsoft rechnen selbst in die Kontowaehrung um. Ohne ziel: EUR.
  // Positionen aus einer anderen Waehrung (in einem anderen Markt hinzugefuegt) gehen
  // ueber EUR: Betrag / Kurs der Position × Kurs des Ziels. Naeherung (gerundete Preise).
  function listenwert(positionen, ziel) {
    var zielWaehrung = (ziel && ziel.waehrung) || 'EUR';
    var zielKurs = zielWaehrung !== 'EUR' && ziel && ziel.kurs > 0 ? ziel.kurs : 1;
    var summe = 0;
    (positionen || []).forEach((p) => {
      if (p.preis == null) return;
      var faktor =
        p.preis_einheit === 'm2' && p.akustik && p.akustik.area_m2 ? p.akustik.area_m2 : 1;
      var betrag = (p.preis / 100) * (Number(p.menge) || 1) * faktor;
      var waehrung = p.waehrung || 'EUR';
      if (waehrung !== zielWaehrung) {
        const kurs = waehrung !== 'EUR' && p.kurs > 0 ? p.kurs : 1;
        betrag = (betrag / kurs) * zielKurs;
      }
      summe += betrag;
    });
    return rund2(summe);
  }

  function adresse(w, praefix) {
    return {
      street: wert(w[praefix + '.street']),
      postal_code: wert(w[praefix + '.postal_code']),
      city: wert(w[praefix + '.city']),
      country_code: wert(w[praefix + '.country_code']),
    };
  }

  function item(p) {
    var a = p.akustik || {};
    return {
      product: p.produkt || null,
      variant: wert(p.variante),
      sku: wert(p.sku),
      variant_gid: p.variantId ? 'gid://shopify/ProductVariant/' + p.variantId : null,
      quantity: Number(p.menge) || 1,
      list_price: p.preis != null ? rund2(p.preis / 100) : null,
      price_unit: p.preis_einheit === 'm2' ? 'm2' : 'piece',
      currency: p.waehrung || 'EUR',
      width_cm: a.width_cm || null,
      height_cm: a.height_cm || null,
      area_m2: a.area_m2 || null,
      orientation: a.orientation || null,
      motif: a.motif || null,
      multi_part: p.akustik ? Boolean(a.multi_part) : null,
      mounting: a.mounting || null,
      oversize: p.akustik ? Boolean(a.oversize) : null,
      file_link: wert(p.datei_link),
      // Akustikbild ohne Angaben: Listeneintrag von vor dem Release (Entscheidung 24)
      details_missing: Boolean(p.motiv) && !p.akustik,
    };
  }

  // eingabe: { form, werte, positionen, attribution, consent_ad_user_data, jetzt }
  function anfrageDaten(eingabe) {
    var w = eingabe.werte || {};
    var privat = Boolean(w['customer.private']);
    var billing = adresse(w, 'billing');
    billing.vat_id =
      !privat && istEuAusland(billing.country_code) ? wert(w['billing.vat_id']) : null;
    var shipping = null;
    if (w['shipping.different']) {
      shipping = adresse(w, 'shipping');
      shipping.name = wert(w['shipping.name']);
    }
    var herkunft = {};
    [
      'utm_source',
      'utm_medium',
      'utm_campaign',
      'utm_term',
      'utm_content',
      'gclid',
      'msclkid',
      'landing_page',
      'referrer',
    ].forEach((k) => {
      herkunft[k] = wert((eingabe.attribution || {})[k]);
    });
    var vorname = wert(w['customer.first_name']);
    var nachname = wert(w['customer.last_name']);
    return {
      version: 1,
      form: eingabe.form,
      submitted_at: (eingabe.jetzt || new Date()).toISOString(),
      customer: {
        type: privat ? 'private' : 'business',
        company: privat ? null : wert(w['customer.company']),
        name: wert(w['customer.name']) || [vorname, nachname].filter(Boolean).join(' ') || null,
        first_name: vorname,
        last_name: nachname,
        email: wert(w['customer.email']),
        phone: wert(w['customer.phone']),
      },
      billing: billing,
      shipping: shipping,
      items: (eingabe.positionen || []).map(item),
      callback_requested: Boolean(w['akustik.callback']),
      // Bilddatei je Position (items[].file_link). Raumfotos fragt nur das Beratungsformular
      // ab (eigenes Feld) — fuers Angebot sind sie nicht noetig (Konzept §2).
      message: wert(w.message),
      project: projekt(w),
      attribution: herkunft,
      consent_ad_user_data: eingabe.consent_ad_user_data === true,
    };
  }

  // Projektangaben des Beratungsformulars (Details-Bereich). Sie standen frueher als
  // Einzelfelder unter dem Mailtext; jetzt nur noch hier (Grill 2026-10-28).
  // Einsatzbereich kommt als Code aus dem Select, die Mail ist immer deutsch.
  var BEREICH_TEXT = {
    kita: 'KiTa oder Kindergarten',
    schule: 'Schule oder Klassenzimmer',
    buero: 'Büro',
    grossraumbuero: 'Großraumbüro',
    homeoffice: 'Homeoffice',
    gaming: 'Gaming-Zimmer',
    brandschutz: 'Brandschutzanforderung',
    sonstiges: 'Sonstiger Bereich',
  };
  function projekt(w) {
    var bereich = wert(w['project.area']);
    var p = {
      area: bereich ? BEREICH_TEXT[bereich] || bereich : null,
      rooms: wert(w['project.rooms']),
      area_m2: wert(w['project.area_m2']),
      photo_link: wert(w['project.photo_link']),
      interest: wert(w['project.interest']),
    };
    return Object.keys(p).some((k) => p[k] !== null) ? p : null;
  }

  function adressZeilen(a) {
    return [
      a.name,
      a.street,
      [a.postal_code, a.city].filter(Boolean).join(' '),
      a.country_code,
    ].filter(Boolean);
  }

  var TITEL = {
    pdp_quote: 'ANGEBOTSANFRAGE',
    consultation: 'BERATUNGSANFRAGE',
    consultation_quote: 'ANGEBOTSANFRAGE (Beratungsseite)',
  };

  // Mailtext (immer deutsch): Zusammenfassung, die das Team direkt an den Kunden
  // zurueckschicken kann.
  // Die Akustik-Angaben stehen direkt unter ihrer Position; die Varianten-ID nur im JSON.
  function mailText(d) {
    var z = [];
    var c = d.customer;
    var n = d.items.length;
    var kopf = [TITEL[d.form] || 'ANFRAGE'];
    if (n) kopf.push(n === 1 ? '1 Position' : n + ' Positionen');
    if (d.callback_requested) kopf.push('Rückruf gewünscht');
    z.push(kopf.join(' · '));
    var ort = d.billing.city
      ? d.billing.city + (d.billing.country_code ? ' (' + d.billing.country_code + ')' : '')
      : null;
    z.push(
      [c.type === 'private' ? 'Privatkunde' : c.company || 'Firma: –', c.name, ort]
        .filter(Boolean)
        .join(' · '),
    );

    // Beratungsformulare: Das Anliegen ist die Hauptsache und steht oben; beim
    // Angebots-Modal sind es die Positionen, dort bleiben die Anmerkungen am Ende.
    var anliegenOben = d.form !== 'pdp_quote';
    if (anliegenOben && d.message) z.push('', 'ANLIEGEN', d.message);
    var p = d.project;
    if (p) {
      z.push('', 'PROJEKT');
      if (p.area) z.push('Einsatzbereich: ' + p.area);
      if (p.rooms) z.push('Anzahl Räume: ' + p.rooms);
      if (p.area_m2) z.push('Fläche: ca. ' + komma(p.area_m2) + ' m²');
      if (p.photo_link) z.push('Foto-/Plan-Link: ' + p.photo_link);
      if (p.interest) z.push('Interesse: ' + p.interest);
    }

    z.push('', 'KONTAKT');
    z.push(c.type === 'private' ? 'Privatkunde' : 'Firma: ' + (c.company || '–'));
    if (c.name) z.push('Name: ' + c.name);
    if (c.email) z.push('E-Mail: ' + c.email);
    if (c.phone) z.push('Telefon: ' + c.phone);
    if (d.callback_requested) z.push('→ Rückruf zur Umsetzung gewünscht');
    if (d.billing.street || d.billing.city) {
      z.push('', 'RECHNUNGSANSCHRIFT');
      z = z.concat(adressZeilen(d.billing));
      if (d.billing.vat_id) z.push('USt-IdNr.: ' + d.billing.vat_id);
      z.push('', 'LIEFERADRESSE');
      z = z.concat(d.shipping ? adressZeilen(d.shipping) : ['wie Rechnungsanschrift']);
    }

    if (n) {
      z.push('', 'POSITIONEN');
      d.items.forEach((it, i) => {
        z.push(
          i + 1 + ') ' + it.quantity + ' × ' + it.product + (it.variant ? ' – ' + it.variant : ''),
        );
        var e = '   ';
        if (it.details_missing) {
          z.push(e + 'Akustikbild-Angaben: bitte in den Anmerkungen');
        } else if (it.multi_part !== null) {
          z.push(
            e +
              (it.area_m2
                ? 'Format: ' +
                  komma(it.width_cm) +
                  ' × ' +
                  komma(it.height_cm) +
                  ' cm (' +
                  komma(it.area_m2) +
                  ' m²)' +
                  (it.orientation ? ', ' + (it.orientation === 'portrait' ? 'hoch' : 'quer') : '')
                : 'Format: bitte in den Anmerkungen') +
              (it.oversize ? ' – Übergröße: Wir schlagen dir eine Aufteilung vor.' : ''),
          );
          let motiv = 'Motiv: ' + (MOTIV_TEXT[it.motif] || it.motif);
          if (it.motif !== 'suggestion') motiv += ' · Bilddatei: ' + (it.file_link || 'folgt');
          z.push(e + motiv);
          if (it.mounting)
            z.push(e + 'Befestigung: ' + (BEFESTIGUNG_TEXT[it.mounting] || it.mounting));
        }
        // Art.-Nr. statt Preis: Preise stehen im Angebot (Entscheidung 30).
        if (it.sku) z.push(e + 'Art.-Nr. ' + it.sku);
      });
    }
    if (!anliegenOben && d.message) z.push('', 'ANMERKUNGEN', d.message);
    // Kein JSON-Block und keine Herkunftsdaten: Das Team antwortet direkt auf diese Mail,
    // der zitierte Text geht an den Kunden (Entscheidung 30). Herkunft und Werte laufen
    // ueber das Tracking; das Cockpit liest diesen Text per KI.
    return z.join('\n');
  }

  var HERKUNFT_SCHLUESSEL = /^(utm_|gclid$|msclkid$|landing_page$|referrer$)/;
  function entwurfOhneHerkunft(werte) {
    var ergebnis = {};
    Object.keys(werte || {}).forEach((k) => {
      if (!HERKUNFT_SCHLUESSEL.test(k)) ergebnis[k] = werte[k];
    });
    return ergebnis;
  }

  window.FennextAnfrageDaten = {
    istEuAusland: istEuAusland,
    plzOk: plzOk,
    ustIdOk: ustIdOk,
    zahl: zahl,
    istSondergroesse: istSondergroesse,
    laenderListe: laenderListe,
    formatAusOptionen: formatAusOptionen,
    flaeche: flaeche,
    groessePruefen: groessePruefen,
    akustikAuswerten: akustikAuswerten,
    listenwert: listenwert,
    positionsSchluessel: positionsSchluessel,
    zusammenfassung: zusammenfassung,
    anfrageDaten: anfrageDaten,
    mailText: mailText,
    entwurfOhneHerkunft: entwurfOhneHerkunft,
  };
})();
